import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Divider,
  Container,
  Paper,
  Chip,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [value, setValue] = useState(0);

  useEffect(() => {
    const fetchUserOrders = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/order/orders`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        setOrders(data);
      } catch (error) {
        console.error("Error fetching user orders:", error);
      }
    };

    fetchUserOrders();
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const filteredOrders = orders.filter((order) =>
    value === 0 ? !order.isDelivered : order.isDelivered
  );

  return (
    <Container sx={{ mt: 12 }}>
      <Typography variant="h4" gutterBottom>
        My Orders
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="order status tabs"
        >
          <Tab label="Pending" />
          <Tab label="Delivered" />
        </Tabs>
      </Box>

      {filteredOrders.map((order) => (
        <Paper key={order._id} elevation={1} sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" gutterBottom>
            Order ID #{order._id}
          </Typography>
          <Typography gutterBottom>
            Placed on: {new Date(order.createdAt).toLocaleString()}
          </Typography>
          <Typography gutterBottom>
            Total: ₹{order.totalPrice.toFixed(2)}
          </Typography>
          <Typography gutterBottom>
            Status:
            <Chip
              size="small"
              label={order.isDelivered ? "Delivered" : "Pending"}
              variant="outlined"
              color={order.isDelivered ? "success" : "warning"}
            />
          </Typography>
          <Divider />
          <List>
            {order.orderItems.map((item) => (
              <ListItem key={item._id}>
                <ListItemAvatar>
                  <Avatar src={item.menu.image} alt={item.menu.name} />
                </ListItemAvatar>
                <ListItemText
                  primary={item.menu.name}
                  secondary={`Quantity: ${
                    item.quantity
                  } | Price: ₹${item.price.toFixed(2)}`}
                />
              </ListItem>
            ))}
          </List>
          <Divider />
        </Paper>
      ))}
    </Container>
  );
};

export default MyOrders;
